import React from "react";
import { Box, Avatar, Typography, Stack } from "@mui/material";

const PortfolioCard = ({ item }) => {
  const faces = Array.isArray(item?.faces) ? item.faces.filter(Boolean) : [];
  const faceSize =
    faces.length > 1
      ? Math.max(
          24,
          Math.min(40, Math.floor(160 / (1 + 0.75 * (faces.length - 1))))
        )
      : 40;

  const handleClick = () => {
    if (item.url) {
      window.open(item.url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: "pointer",
        width: { xs: "90%", sm: 200 },
        height: { xs: 230, sm: 250 }, // Fixed consistent height
        borderRadius: "12px",
        boxShadow: "0px 2px 10px rgba(0,0,0,0.06)",
        transition: "0.3s",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "&:hover": {
          boxShadow: "0px 16px 64px rgba(22, 39, 94, 0.16)",
        },
      }}
    >
      <Box sx={{ p: 2, textAlign: "center" }}>
        {/* Logo */}
        <Box
          component="img"
          src={item.logo}
          alt={item.name}
          sx={{
            width: "100px",
            height: "50px",
            objectFit: "contain",
            mb: 1.5,
          }}
        />

        {/* One image stays the wide strip; several render as separate faces */}
        {faces.length === 1 && (
          <Stack direction="row" justifyContent="center" mb={1.5}>
            <Box
              component="img"
              src={faces[0]}
              alt="face-0"
              sx={{
                width: "100%",
                height: 40,
                objectFit: "contain",
              }}
            />
          </Stack>
        )}

        {faces.length > 1 && (
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            mb={1.5}
            sx={{ height: 40 }}
          >
            {faces.map((face, index) => (
              <Avatar
                key={`${face}-${index}`}
                src={face}
                alt={`face-${index}`}
                sx={{
                  width: faceSize,
                  height: faceSize,
                  border: "2px solid #fff",
                  boxSizing: "border-box",
                  ml: index === 0 ? 0 : `-${Math.round(faceSize * 0.22)}px`,
                  zIndex: faces.length - index,
                }}
              />
            ))}
          </Stack>
        )}

        {/* Description */}
        <Typography
          variant="body2"
          color="#1D4979"
          sx={{
            fontSize: "12px !important",
            height: 40, // lock height so all cards match
            overflow: "hidden",
          }}
        >
          {item.description}
        </Typography>

        {/* Dimensions */}
        <Stack
          direction="row"
          spacing={1}
          justifyContent="center"
          mt={2}
          flexWrap="wrap"
        >
          {(item.dimensions || []).map((icon, index) => (
            <Avatar
              key={index}
              src={icon}
              sx={{
                width: 25,
                height: 25,
                backgroundColor: "#f0f0f0",
              }}
              variant="rounded"
            />
          ))}
        </Stack>
      </Box>

      {/* Pending Chip */}
      {item.status === "pending" && (
        <Box
          textAlign="center"
          sx={{
            background: "#FFF1E6",
            color: "#9A3923",
            borderRadius: "0px 0px 12px 12px",
            py: 0.5,
          }}
        />
      )}
    </Box>
  );
};

export default PortfolioCard;
